import React, { useState } from "react";
import Calender from "../../components/dashboard-components/Calender";
import SearchComponent from "../../components/dashboard-components/SearchComponent";
import StablecoinWidget from "../../components/dashboard-components/StablecoinWidget";
import Widgets from "../../components/dashboard-components/Widgets";
import { useSearchParams } from "react-router-dom";
import { useBalance, useTotalBalance } from "../../sevices/hooks/account";
import BalanceTable from "../../components/balanceTable";

// Types for the balance data
interface BalanceData {
  data: {
    eur: number;
    gbp: number;
    ngn: number;
    usd: number;
    usdc: number;
    usdt: number;
  };
  status: string;
}

// Props for the BalanceWidget component
interface BalanceWidgetProps {
  color: string;
  currency: string;
  symbol: string;
  amount?: number;
  border: string;
  redirect: string;
  isLoading: boolean;
}

// Props for the widget container components
interface WidgetContainerProps {
  data?: BalanceData;
  isLoading: boolean;
}

// const SkeletonLoader = () => {
//   return (
//     <div className="animate-pulse space-y-3">
//       <div className="h-4 w-24 bg-gray-200 rounded" />
//       <div className="h-8 w-32 bg-gray-200 rounded" />
//     </div>
//   );
// };



interface BalanceWidgetProps {
  color: string;
  currency: string;
  symbol: string;
  amount?: number;
  border: string;
  redirect: string;
  isLoading: boolean;
}

const formatLargeNumber = (num: number): string => {
  const absNum = Math.abs(num);
  if (absNum >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(2) + 'B';
  } else if (absNum >= 1_000_000) {
    return (num / 1_000_000).toFixed(2) + 'M';
  } else if (absNum >= 1_000) {
    return (num / 1_000).toFixed(2) + 'K';
  }
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const SkeletonLoader = () => {
  return (
    <div className="animate-pulse space-y-3">
      <div className="h-4 w-24 bg-gray-200 rounded" />
      <div className="h-8 w-32 bg-gray-200 rounded" />
    </div>
  );
};

const BalanceWidget = ({
  color,
  currency,
  symbol,
  amount = 0,
  border,
  redirect,
  isLoading,
}: BalanceWidgetProps) => {
  const formattedAmount = formatLargeNumber(amount);
  const fullAmount = amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  // Calculate text size based on amount length
  const getTextSize = () => {
    const length = formattedAmount.length;
    if (length > 12) return 'text-lg';
    if (length > 9) return 'text-xl';
    return 'text-2xl';
  };

  return (
    <div
      className="w-1/4 p-4 rounded-lg cursor-pointer transition-all  overflow-hidden"
      style={{ backgroundColor: color, border: border }}
      onClick={() => (window.location.href = redirect)}
    >
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        <div className="flex flex-col">
          <p className="text-gray-600 text-sm mb-1 truncate">{currency}</p>
          <div
            className={`${getTextSize()} font-bold flex items-center truncate`}
            title={`${symbol}${amount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
          >
            <span className="flex-shrink-0">{symbol}</span>
            <span className="truncate">{formattedAmount}</span>
          </div>

          {/* Full amount shown on hover */}
          <div
            className="text-xs text-gray-500 mt-1 truncate hover:text-gray-700"
            title={`${symbol}${fullAmount}`}
          >
            <span className="flex-shrink-0">{symbol}</span>{" "}
            {fullAmount}
          </div>
        </div>
      )}
    </div>
  );
};


const Balances = () => {
  const [currentTab, setCurrentTab] = useState("fiat");
  const [searchParams] = useSearchParams();
  const [pageSize, setPageSize] = useState(15);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || ""
  );
  const { data } = useTotalBalance();
  const { data: userActivities, isLoading } = useBalance({
    pageSize,
    page,
    name: searchTerm, 
  });

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setPage(1); // Reset to first page when searching
  };
  console.log(data, "data");
  console.log(userActivities, " userActivities");
  return (
    <div className="h-screen w-full bg-[#fff] p-5 md:pr-5 md:pl-8 ">
      <div className="flex flex-row items-center justify-between  mt-5">
        <h1 className="font-bold text-2xl text-[#071827] md:pb-2">Balances</h1>
        <div className="flex items-start  gap-3">
          <div className="toggle w-60 h-12 md:h-10 flex border border-[#0eb683] mb-6 md:mb-4 self-center justify-between rounded-lg cursor-pointer p-1">
            <div
              className={`px-2 flex-1 whitespace-nowrap flex items-center justify-center transition-all duration-500 rounded-md ${
                currentTab === "fiat" ? "bg-[#0eb683] text-white" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                setCurrentTab("fiat");
              }}
            >
              Fiat
            </div>
            <div
              className={`px-2 flex-1 whitespace-nowrap flex items-center justify-center transition-all duration-500 rounded-md ${
                currentTab === "Stablecoin" ? "bg-[#0eb683] text-white" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                setCurrentTab("Stablecoin");
              }}
            >
              Stablecoin
            </div>
          </div>
          {/* <Calender /> */}
        </div>
      </div>

      {currentTab === "fiat" ? (
        <div>
          {/* @ts-ignore */}
          <BalanceWidgets data={data} isLoading={isLoading} />
          <div className="py-2">
            <SearchComponent
              placeholder={"Search Revenue"}
              onSearch={handleSearch}
            />
          </div>

          <div>
            <BalanceTable
              data={userActivities?.data?.data}
              isLoading={isLoading}
              page={page}
              onPageChange={setPage}
              currentTab={currentTab}
            />
          </div>
        </div>
      ) : (
        <div>
          <div className="">
            {/* @ts-ignore */}
            <StablecoinWidgets data={data} isLoading={isLoading} />
          </div>

          <div className="py-2">
            <SearchComponent
              placeholder={"Search Revenue"}
              onSearch={handleSearch}
            />
          </div>

          <div>
            <BalanceTable
              data={userActivities?.data?.data}
              isLoading={isLoading}
              page={page}
              onPageChange={setPage}
              currentTab={currentTab}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Balances;

const BalanceWidgets: React.FC<WidgetContainerProps> = ({
  data,
  isLoading,
}) => {
  return (
    <div className="flex gap-3">
      <BalanceWidget
        color="#fff"
        currency="NGN Revenue"
        symbol="₦"
        // @ts-ignore
        amount={data?.data?.data?.ngn}
        border="1px solid #0EB683"
        redirect="/dashboard/accounts/ngn"
        isLoading={isLoading}
      />
      <BalanceWidget
        color="#C4FFF4"
        currency="USD Collections"
        symbol="$"
        // @ts-ignore
        amount={data?.data?.data?.usd}
        border="1px solid #C4FFF4"
        redirect="/dashboard/accounts/usd"
        isLoading={isLoading}
      />
      <BalanceWidget
        color="#FFDECF"
        currency="GBP Collections"
        symbol="£"
        // @ts-ignore
        amount={data?.data?.data?.gbp}
        border="1px solid #FFDECF"
        redirect="/dashboard/accounts/gbp"
        isLoading={isLoading}
      />
      <BalanceWidget
        color="#E8EAFF"
        currency="EUR Collections"
        symbol="€"
        // @ts-ignore
        amount={data?.data?.data?.eur}
        border="1px solid #E8EAFF"
        redirect="/dashboard/accounts/eur"
        isLoading={isLoading}
      />
    </div>
  );
};

const StablecoinWidgets: React.FC<WidgetContainerProps> = ({
  data,
  isLoading,
}) => {
  return (
    <div className="flex gap-3">
      <BalanceWidget
        color="#fff"
        currency="USDC Balance"
        symbol="USDC" // @ts-ignore
        amount={data?.data?.data?.usdc}
        border="1px solid #0EB683"
        redirect="/dashboard/accounts/usdc"
        isLoading={isLoading}
      />
      <BalanceWidget
        color="#C4FFF4"
        currency="USDT Balance"
        symbol="USDT"
        // @ts-ignore
        amount={data?.data?.data?.usdt}
        border="1px solid #C4FFF4"
        redirect="/dashboard/accounts/usdt"
        isLoading={isLoading}
      />
    </div>
  );
};
